// extracted by mini-css-extract-plugin
module.exports = {"Card":"card_Card__bnRtz","cardImage":"card_cardImage__4G5nX","cardTitle":"card_cardTitle__7b0xt","cardClassification":"card_cardClassification__pu4Xt"};